import Logger from '../logger';

class ThemeFloatingContentBanner {

	// Vars
	// ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒

	/**
	 * Class constructor
	 */
	constructor(dom) {

		this.NAME = 'ThemeFloatingContentBanner';

		this.dom = dom;
	}

	/**
	 * init - Initialize the component
	 *
	 * Premium approach: Complete restraint - no scroll effects.
	 * Let the content speak for itself with clean, elegant presentation.
	 **/
	init() {
		Logger.info(`${this.NAME} > init`);
		// No scroll effects - premium restraint
	}
}

export default ThemeFloatingContentBanner;
